import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { MultiSelect } from '@/components/react-hook-form/MultiSelect';
import type { Office } from '../../query';
import type { Schema } from '../../schema';
import { laborInsuranceNumber } from '../../utils';

interface OfficeProps {
  loading: boolean;
  offices?: Office[];
}

export const AggregationOffices: FC<OfficeProps> = ({ loading, offices }) => {
  const { control } = useFormContext<Schema>();
  const officeId = useWatch({ control, name: 'officeId' });
  const officeSnapshot = useWatch({ control, name: 'officeSnapshot' });
  const laborInsuranceNumberOfSelectedOffice = laborInsuranceNumber(officeSnapshot);
  const options =
    offices && officeId
      ? offices
          .filter(office => laborInsuranceNumber(office) === laborInsuranceNumberOfSelectedOffice)
          .map(office => ({ value: office.id, label: office.name }))
      : [];

  return (
    <Panel>
      <Headding>集計に含める事業所</Headding>
      <Item>
        <MultiSelect
          name="aggregationOfficeIds"
          options={options}
          disabled={loading}
          isLoading={loading}
          noOptionsMessage={() => (officeId ? '適用事業所が見つかりません' : '基本情報の適用事業所を選択してください')}
        />
      </Item>
    </Panel>
  );
};
